/*
  jd-pointer-fill.js
  Writes the pointer position into --mouse-in-button-x/y on any element with
  the .jd-fill class so its teal fill grows from where the cursor or finger
  landed. On pointerdown it also adds .jd-fill-active for a short hold, which
  is how touch devices get the fill (:hover never fires there).

  Load once from theme.liquid:
    <script src="{{ 'jd-pointer-fill.js' | asset_url }}" defer="defer"></script>

  Any button that opts in needs:
    - class="jd-fill" on the element
    - CSS that reads --mouse-in-button-x/y (origin) and --jd-fill-r (end
      radius) and reacts to :hover (desktop) and .jd-fill-active (touch)
*/
(function () {
  'use strict';
  if (window.__jdPointerFillBound) return;
  window.__jdPointerFillBound = true;

  // .jd-fill is the opt-in class. The others are kept so existing markup
  // works before it has been updated to carry .jd-fill.
  var SELECTOR = '.jd-fill, .jd-cta .single-add-to-cart-button, .pww__add-btn, .ripple-fill-btn';
  var FILL_HOLD_MS = 1200; // fill (650ms) plus a short hold before it retracts

  function findButton(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return null;
    return target.closest(SELECTOR);
  }

  function setOrigin(btn, event) {
    var rect = btn.getBoundingClientRect();
    var x = event.clientX - rect.left;
    var y = event.clientY - rect.top;
    // Radius needed to reach the farthest corner from this point, plus a
    // small margin. Using the real distance instead of a fixed percentage
    // means every button is fully covered at the same point on the easing
    // curve, so the fill feels the same speed whatever the button's size
    // or where the pointer entered.
    var dx = Math.max(x, rect.width - x);
    var dy = Math.max(y, rect.height - y);
    var r = Math.sqrt(dx * dx + dy * dy) * 1.05;
    btn.style.setProperty('--mouse-in-button-x', x + 'px');
    btn.style.setProperty('--mouse-in-button-y', y + 'px');
    btn.style.setProperty('--jd-fill-r', r + 'px');
  }

  // Desktop: keep the origin tracking the cursor while it moves over the button.
  function track(event) {
    var btn = findButton(event);
    if (btn) setOrigin(btn, event);
  }

  // Touch (and click): fix the origin at the contact point and run the fill
  // via a class.
  function press(event) {
    var btn = findButton(event);
    if (!btn || btn.disabled) return;
    setOrigin(btn, event);
    btn.classList.add('jd-fill-active');
    clearTimeout(btn.__jdFillTimer);
    btn.__jdFillTimer = setTimeout(function () {
      btn.classList.remove('jd-fill-active');
    }, FILL_HOLD_MS);
  }

  document.addEventListener('mouseover', track, true);
  document.addEventListener('mousemove', track, true);
  document.addEventListener('mouseout', track, true);
  document.addEventListener('pointerdown', press, true);
})();